import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CommonService } from './common.service';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  constructor(
    private http: HttpClient,
    private commonService: CommonService
  ) { }

  getAdminDashboard(){
    return this.http.get<any>(this.commonService.apiUrl + '/dashboard/admin', {})
  }
}
